import React from 'react'
import ShoppingCart from './ShoppingCart'
import {useAppDispatch, useAppSelector} from '../../store/hooks'
import {FocusTrap} from 'focus-trap-react'
import {getLogger} from '../../services/logging'
import {
  clearValidations,
  hideCartValidations,
  selectCartValidationErrors,
  selectIsCartValidationOpen,
  selectLatestOffers
} from '../../store/slices/shoppingCartValidationSlice'
import Alert from '../common/Alert'
import {
  selectCartItems,
  updateAllItems
} from '../../store/slices/shoppingCartSlice'
import {applyShoppingCartChanges} from '../../services/cartValidation'

const logger = getLogger('ShoppingCartValidationModal')

const ShoppingCartValidationModal = () => {
  const dispatch = useAppDispatch()
  const shoppingCartItems = useAppSelector(selectCartItems)
  const validationErrors = useAppSelector(selectCartValidationErrors)
  const latestOffers = useAppSelector(selectLatestOffers)
  const isOpen = useAppSelector(selectIsCartValidationOpen)

  return (
    <>
      {isOpen && (
        <FocusTrap active={isOpen}>
          <div className="modal modal-open" role="dialog" aria-modal="true">
            <div className="modal-box w-[95%] max-w-screen-md max-h-[95%] px-4 md:px-6">
              <div>
                <h1 className="text-xl font-bold mb-2">
                  Shopping Cart Changes
                </h1>

                <Alert type="error" className="mt-2 mb-4">
                  <p>
                    Some items in your cart have changed. Please review and
                    accept the changes. You are free to make additional changes
                    to your cart.
                  </p>
                </Alert>

                <ShoppingCart validationMode={true} />

                <div className="modal-action">
                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      const updatedCartItems = applyShoppingCartChanges(
                        shoppingCartItems,
                        validationErrors,
                        latestOffers
                      )

                      logger.info({
                        message: 'Accepting changes to shopping cart.',
                        data: {updatedCartItems}
                      })

                      dispatch(hideCartValidations())
                      dispatch(updateAllItems(updatedCartItems))
                      dispatch(clearValidations())
                    }}
                  >
                    Accept Changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </FocusTrap>
      )}
    </>
  )
}

export default ShoppingCartValidationModal
